module.exports = __webpack_public_path__ + "static/img/chuxuka.1a965d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chuxuka.png
// module id = 9X3I
// module chunks = 128